import { InfoCircleFilled } from '@ant-design/icons';
import { Tooltip, Layout, Skeleton } from 'antd';
import Sider from 'antd/lib/layout/Sider';
import { ReactNode } from 'react';

import { LogoPmis } from '../../../assets/logoPmis/logoPmis';
import { LogoSuape } from '../../../assets/logoSuape/logoSuape';
import { LogoCliente } from '../../LogoCliente';
import shipIsometric from '../../../assets/shipIsometric/ShipIsometric@3x.png';
import { LeftContent, Container } from './styles';
import { useBranding } from '../../../context/brandingContext';

type LayoutLoginProps = {
  children: ReactNode;
};

export function LayoutLogin(props: LayoutLoginProps) {
  const { branding, loading } = useBranding();

  return (
    <Container>
      <Layout>
        <LeftContent>
          <Skeleton loading={loading}>
            <div>
              <LogoCliente />
              {props.children}
            </div>
          </Skeleton>
        </LeftContent>
      </Layout>

      <Sider
        width="50%"
        style={{
          backgroundColor: branding?.primaryColor || '#ffffff',
        }}
      >
        <img
          width="100%"
          height="100%"
          src={shipIsometric}
          alt="Embarcações no porto"
        />

        <div
          style={{
            position: 'absolute',
            right: '30px',
            bottom: '30px',
          }}
        >
          <Tooltip
            placement="left"
            title="Infographic vector created by Upklyak"
            overlayStyle={{ maxWidth: '500px' }}
          >
            <InfoCircleFilled
              style={{
                color: 'var(--neutral_light)',
                marginLeft: '10px',
              }}
            />
          </Tooltip>
        </div>
      </Sider>
    </Container>
  );
}
